import { Flex } from '@chakra-ui/react';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Loading = () => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100%"
      height="100vh"
      backgroundColor="surfaceSecondaryFill"
      flexDirection="column"
      textAlign="center"
    >
      <FontAwesomeIcon icon={faSpinner} spin size="3x" />
    </Flex>
  );
};

export default Loading;
